import { COLORS } from '@/styles/colorTheme';
import styled from 'styled-components';
import { Settings } from 'lucide-react';

const Img = styled.img`
  width: 24px;

  filter: ${(props) => (props.convert ? 'invert(100%)' : '')};
`;

function SettingsIcon({ state = 'mouseup', isSelected = false }) {
  let color = COLORS.Text400;
  if (state === 'mousedown') color = '#fff';
  return <Settings color={color} size={22} strokeWidth={1.5} />;
}

export default SettingsIcon;
